module.exports = __webpack_public_path__ + "media/a4.e683f8a2.mp3";